import { AlertTriangle, Check, CloudOff, Loader2 } from 'lucide-react';
import { formatarDiaMes, formatarDiaSemana } from '@nexital/shared';
import { useQuadro } from '../../application/dependencias';
import type { Salvamento } from '../../application/quadro-store';

const SALVAMENTO: Record<Salvamento, { texto: string; classe: string }> = {
  salvo: { texto: 'Tudo salvo', classe: 'pilula--sucesso' },
  salvando: { texto: 'Salvando…', classe: 'pilula--informacao' },
  erro: { texto: 'Erro ao salvar', classe: 'pilula--urgencia' },
  conflito: { texto: 'Alterado por outra pessoa — recarregado', classe: 'pilula--aguardando' },
  offline: { texto: 'Offline', classe: 'pilula--aguardando' },
};

/** Título, data e indicador de salvamento (RQ-COL-007), fixos sobre o quadro. */
export function Cabecalho({ titulo }: { titulo: string }) {
  const salvamento = useQuadro((s) => s.salvamento);
  const pendentes = useQuadro((s) => s.pendentesOffline);
  const hoje = new Date();
  const { classe } = SALVAMENTO[salvamento];
  const texto = salvamento === 'offline' ? `Offline com ${pendentes} pendente${pendentes === 1 ? '' : 's'}` : SALVAMENTO[salvamento].texto;
  const Icone = { salvo: Check, salvando: Loader2, erro: AlertTriangle, conflito: AlertTriangle, offline: CloudOff }[salvamento];
  return (
    <header className="cabecalho-quadro">
      <h1>{titulo}</h1>
      <span className="cabecalho-quadro__data">
        {formatarDiaMes(hoje)} • {formatarDiaSemana(hoje)}
      </span>
      <span className={`pilula ${classe}`} role="status">
        <Icone size={14} aria-hidden className={salvamento === 'salvando' ? 'girando' : undefined} /> {texto}
      </span>
    </header>
  );
}
